import React from 'react';
import { useTranslation } from 'react-i18next';
import AppButton from '../app-button';

const ClearCacheButton: React.FC = () => {
  const { t } = useTranslation();

  const clearCache = async () => {
    try {
      // Clear SW-managed caches (precache + runtime cache)
      if (window.caches) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cache) => caches.delete(cache)));
      }

      // Force the service worker to re-fetch everything on next load
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }
    } catch (err) {
      console.error('Cache clearing failed:', err);
    }

    // Reload the page to fetch fresh assets and re-register the SW
    window.location.reload();
  };

  return (
    <AppButton fullWidth color="primary" variant="contained" onClick={clearCache}>
      {t('fallback.clear-button-text')}
    </AppButton>
  );
};

export default ClearCacheButton;
